import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fund-cash-payment-status-badge',
  templateUrl: './fund-cash-payment-status-badge.component.html',
  styleUrls: ['./fund-cash-payment-status-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FundCashPaymentStatusBadgeComponent {
  @Input() isPaid = false;
  @Input() isAuthorized = false;

  get status(): string {
    return this.isPaid ? 'paid' : this.isAuthorized ? 'authorized' : 'to-pay';
  }
}
